/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

const FixAspect = ({ ratio = '1:1', children, style, className }) => {
    // Destructure resulting array into 'width' and 'height'
    const [width, height] = ratio.split(':');

    // Calculate percentage value using 'width' and 'height'
    const percentage = (height / width) * 100;

    return (
        <div style={style}>
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: 'auto',
                    paddingTop: `${percentage}%`,
                    overflow: 'hidden'
                }}
            >
                <div
                    className={className}
                    style={{
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        bottom: '0',
                        left: '0'
                    }}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export default FixAspect;
